import axios from "axios";

class Connect {
  #baseUrlApi = process.env.REACT_APP_APIMCP;
  #token = null;

  #config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: null,
    },
  };

  setToken(token) {
    this.#token = token;
    this.#config.headers.Authorization = "Bearer " + this.#token;
  }

  getToken() {
    return this.#token;
  }

  async post(path, data) {
    try {
      const url = `${this.#baseUrlApi}${path}`;
      const response = await axios.post(url, data, this.#config);
      return response;
    } catch (error) {
      console.error("Error en la solicitud POST:", error);
      throw error;
    }
  }

  async get(path) {
    try {
      const url = `${this.#baseUrlApi}${path}`;
      const response = await axios.get(url, this.#config);
      return response.data;
    } catch (error) {
      console.error("Error en la solicitud GET:", error);
      throw error;
    }
  }

  async getBlob(path) {
    try {
      const url = `${this.#baseUrlApi}${path}`;
      const response = await axios.get(url, {
        ...this.#config,
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error("Error en la solicitud GET Blob:", error);
      throw error;
    }
  }

  async postFormData(path, formData) {
    try {
      const url = `${this.#baseUrlApi}${path}`;
      const config = {
        headers: {
          Authorization: this.#token ? `Bearer ${this.#token}` : undefined,
          Accept: 'application/json',
        },
      };
      const response = await axios.post(url, formData, config);
      return response;
    } catch (error) {
      console.error("Error en la solicitud POST con FormData:", error);
      throw error;
    }
  }

  async delete(path) {
    try {
      const url = `${this.#baseUrlApi}${path}`;
      const response = await axios.delete(url, this.#config);
      return response.data;
    } catch (error) {
      console.error("Error en la solicitud DELETE:", error);
      throw error;
    }
  }

  async update(path, data) {
    try {
      const url = `${this.#baseUrlApi}${path}`;
      const response = await axios.put(url, data, this.#config);
      return response.data;
    } catch (error) {
      console.error("Error en la solicitud UPDATE:", error);
      throw error;
    }
  }
}

export default Connect;
